export default __webpack_public_path__ + "static/media/mapMarker.43079b7a.svg";